import React from "react";

import styles from "./EmptyState.module.scss";
import emptyImage from "@/assets/img/newEmpty.svg";

type Props = {
  img?: any;
  icon?: React.ReactNode;
  title?: string;
  text?: string;
  className?: string;
  backgroundColor?: string;
};

const EmptyState = ({ img, icon, title, text, className = "", backgroundColor }: Props) => {
  return (
    <div
      className={`${styles.emptyState} ${className} gradientBorder`}
      style={{ background: backgroundColor }}
    >
      {icon ? (
        <span className={styles.emptyStateIcon}>{icon}</span>
      ) : (
        <img src={img || emptyImage} />
      )}
      <h3>{title}</h3>
      <p>{text}</p>
    </div>
  );
};

export default EmptyState;
